import { UseCase } from '@/core/base/use-case';
import { UpdateSummaryResponse } from '../models/update-summary-response.model';
import { UpdateSummaryRepository } from '../repositories/update-summary.repository';
import { Observable } from 'rxjs';

export class GetUpdateSummaryUseCase
    implements UseCase<never, UpdateSummaryResponse>
{
    constructor(private readonly repository: UpdateSummaryRepository) {}

    execute(): Observable<UpdateSummaryResponse> {
        return this.repository.getUpdateSummary();
    }
}
